import { useContext as r, createContext as o } from "react";
const m = o(!1);
function l() {
  return r(m);
}
var n = /* @__PURE__ */ ((t) => (t[t.xs = 0] = "xs", t[t.sm = 600] = "sm", t[t.md = 900] = "md", t[t.lg = 1024] = "lg", t[t.xl = 1440] = "xl", t))(n || {});
export {
  n as D,
  m as E,
  l as u
};
//# sourceMappingURL=app-51178863.mjs.map
